export default __webpack_public_path__ + "video-section-blob-2.svg";